import { _js } from '@ifixit/localize';
import { FrameModules } from 'Shared/frame_modules';
import LoadingIndicator from 'Shared/loading_indicator';

FrameModules.add('PatrolThresholdFrameModule', () => {
   when($('patrolThreshold'), form => {
      let save = $E('#patrolThreshold button');
      let input = form.getElement('input.value');

      let type = form.type.value;
      // The maximum value the user is allowed to set
      let max_allowed = form.max_allowed.value.toInt();
      // The maximum value anyone can set
      let max_displayed = form.max_displayed.value.toInt();
      // The value that gets set when "infinite" is submitted
      let infinite = form.infinite.value.toInt();

      let infChar = '∞';
      let initial_value = input.value === infChar ? infinite : input.value.toInt();

      let slider = $('patrolSlider');
      slider.set('max', max_allowed);
      slider.value = initial_value;

      // At the maximum the visible value is ∞; announce that instead of
      // letting a screen reader read the raw number.
      let updateValueText = () => {
         if (slider.value.toInt() === max_displayed) {
            slider.set('aria-valuetext', _js('No limit'));
         } else {
            slider.removeProperty('aria-valuetext');
         }
      };
      updateValueText();

      slider.addEvent('input', () => {
         let step = slider.value.toInt();
         input.value = step === max_displayed ? infChar : step;
         updateValueText();
      });

      slider.addEvent('change', () => {
         save.disabled = false;
      });

      input.addEvent('input', () => {
         save.disabled = false;
      });

      // Typing a threshold should move the slider too, not leave it at a
      // stale position that the next drag would commit over the typed value.
      input.addEvent('change', () => {
         let typed = input.value === infChar ? max_displayed : input.value.toInt();
         if (!isNaN(typed)) {
            // The browser clamps to [0, max_allowed].
            slider.value = typed;
            updateValueText();
         }
      });

      form.addEvent('submit', function (ev) {
         ev.stop();

         let docid = this.docid.value;
         let threshold = input.value === infChar ? 'inf' : input.value;

         let request = new Request.AjaxIO('saveThreshold').send(type, docid, threshold);
         request.then(response => {
            this.submitButton.blur();
            input.blur();

            if (response == 'inf' || response >= max_allowed) {
               slider.value = max_allowed;
               input.value = infChar;
            } else {
               slider.value = response;
               input.value = response;
            }
            updateValueText();

            save.disabled = true;
         });

         LoadingIndicator.withPromise(request);
      });

      save.disabled = true;
   });
});
